import { QuestionCircleOutlined } from '@ant-design/icons'
import { PageHeader, Tooltip, Typography } from 'antd'

export function PageHeaderWithHelpIcon ({ title, titleLevel, iconOnClick }) {
  return (
    <PageHeader
      title={<Typography.Title level={titleLevel} style={{ marginBottom: 0 }}>{title}</Typography.Title>}
      subTitle={<Typography.Text type='secondary' onClick={iconOnClick}><Tooltip open={false}><QuestionCircleOutlined style={{ cursor: 'help' }} /></Tooltip></Typography.Text>}
      style={{ paddingLeft: 0, paddingRight: 0 }}
    />
  )
}
